export default {
  title: {
    id: 'buyback_options_Payment_table_title',
    defaultMessage: 'Payment methods',
  },
  payment_method_bank_transfer_title: {
    id: 'buyback_options_payment_by_Bank_transfer_title',
    defaultMessage: 'By bank transfer',
  },
  payment_method_card_title: {
    id: 'buyback_options_payment_by_card_title',
    defaultMessage: 'By card',
  },
  payment_method_preferred_label: {
    id: 'buyback_options_payment_default_tag',
    defaultMessage: 'Default',
  },
  payment_method_bank_transfer_description: {
    id: 'buyback_options_payment_by_Bank_transfer_description',
    defaultMessage: 'Pay Back Market customers via bank transfer.',
  },
  payment_method_card_description: {
    id: 'buyback_options_payment_by_card_description',
    defaultMessage: 'Pay Back Market customers directly via your credit card.',
  },
  payment_method_cards_accepted: {
    id: 'buyback_options_payment_by_card_cards_accepted',
    defaultMessage: 'Cards accepted',
  },
  payment_method_edit_cta: {
    id: 'buyback_options_payment_edit_cta',
    defaultMessage: 'Edit',
  },
  payment_method_preferred_cta: {
    id: 'buyback_options_payment_default_cta',
    defaultMessage: 'Set as default',
  },
}
